import { DeviceConnectivity, DeviceConnectivityResponse, DeviceConnectivityRow } from '../../types/Devices';

// Time of the actual connect/disconnect event as observed by device-gateway.
// Falls back to createdAt (Mongo insert time) for rows written before eventAt
// existed, so older history still renders (with slightly less precise times).
function eventTime(item: DeviceConnectivity): number {
  return new Date(item.eventAt ?? item.createdAt).getTime();
}

export function stitchConnectivityPages(pages: DeviceConnectivityResponse[]): DeviceConnectivityRow[] {
  const allItems = pages.flatMap((page) => page.results);
  if (allItems.length === 0) {
    return [];
  }

  // The API returns newest-first, and pages may not arrive/merge in a
  // guaranteed order (see mergeNewestIntoFirstPage) — sort explicitly so the
  // stitching below is correct regardless of input order or page boundaries.
  const sorted = [...allItems].sort((a, b) => eventTime(a) - eventTime(b));

  const results: DeviceConnectivityRow[] = [];
  let openConnected: DeviceConnectivity | undefined;

  sorted.forEach((item) => {
    if (item.status === 'connected') {
      if (openConnected) {
        // Two "connected" events in a row with no disconnect between them
        // (e.g. duplicate/retried event) — keep the earlier one.
        return;
      }
      openConnected = item;
      return;
    }

    // item.status === 'disconnected'
    if (!openConnected) {
      // Two "disconnected" in a row, or a disconnect with no matching
      // preceding connect in the loaded window — nothing to close.
      return;
    }
    results.push({
      deviceId: openConnected.deviceId,
      status: 'Online',
      startDate: String(openConnected.eventAt ?? openConnected.createdAt),
      endDate: String(item.eventAt ?? item.createdAt),
    });
    openConnected = undefined;
  });

  if (openConnected) {
    results.push({
      deviceId: openConnected.deviceId,
      status: 'Online',
      startDate: String(openConnected.eventAt ?? openConnected.createdAt),
      endDate: null,
    });
  }

  // Preserve the existing newest-first display order (API/UI convention).
  return results.reverse();
}
